import { render, staticRenderFns } from "./ExchangeCustomerInfo.vue?vue&type=template&id=2871145b"
import script from "./ExchangeCustomerInfo.vue?vue&type=script&lang=js"
export * from "./ExchangeCustomerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports